<template>
  <div class="l-body">
    <Top/>
    <div class="wrap" :class="bgId">
      <div class="l-wrap zheng">
        <div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">客服服务</span></div>
      </div>
      <div class="help-jl-box_ls">
        <div class="fql_in_list">
          <div class="ls-wrap zheng">
            <a v-for="wt in wtlist" style="margin-left: 10px;"><router-link :to="{path:'/game', query:{gameid:id,typeid:wt.id,typename:wt.typename,gname:game,vip:vip}}"><img :src="wtBg(wt.typename)"></router-link></a>
          </div>
        </div>
        <div class="ls-wrap zheng">
          <!-- <h1><span id="game">{{game}}</span><span>-</span><span id="faqtype">常见问题</span></h1>
          <h2>COMMON PROBLEM</h2>
          <div class="wentilist">
            <ul id="nav">
              <li class="list" v-for="(data,index) in faqData" @click="an(index)">
                <span :class="data.show==true?'red':'blue'"></span>
                <h3>{{data.question}}</h3>
                <ul class="subMenu" v-show="data.show">
                  <div class="faqzhengwen">
                    <p v-html="data.answer"></p>
                  </div>
                </ul>
              </li>
            </ul>
          </div> -->
          <div class="sp tcs1" v-show="qq">
              <div class="spinners bs02">
                <i id="colose"@click="qqy"></i>
                <div class="tc_zhengwen">
                  <h1 class="tcbiaoti">验证官方QQ</h1>
                <div class="tczwtxt">
                    <li><input class="tctext" id="qq" name="qq" type="text" placeholder="请您输入QQ号码" v-model="qqh"><span><a @click="findqq">验证</a></span></li>
                    <li class="tishitxt">{{qqt}}</li>
                </div>
              </div>
            </div>
          </div>
          <div class="sp tcs1" v-show="ts">
            <div class="spinners bs02">
              <i id="colose" @click="tsy"></i>
              <div class="tc_zhengwen">
                <h1 class="tcbiaoti">投诉建议</h1>
                <div class="tczwtxt">
                  <li>投诉邮箱：TOUSU@ZHAOUC.COM</li>
                  <li>客服经理邮箱：KFJL@ZHAOUC.COM</li>
                  <li class="tcanniu"><a @click="tsy">确认</a></li>
                </div>
              </div>
            </div>
          </div>
          <div class="sp tcs1" v-show="com">
            <div class="spinners bs02">
              <i id="colose" @click="comm"></i>
              <div class="tc_zhengwen">
                <h1 class="tcbiaoti">封号查询/违规举报</h1>
                <div class="tczwtxt">
                  <li>
                  <a @click='$router.push({path:"/complain",query:{id:id,name:game}})'><img src="/static/assets/fenghao.jpg"></a><a @click='$router.push({path:"/complain1",query:{id:id,name:game}})'><img src="/static/assets/weigui.jpg"></a>
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div class="wentipic">
            <a @click="safe"><img src="/static/assets/faq14.jpg"></a>
            <a @click='$router.push({path:"/tracklist"})'><img src="/static/assets/faq07.jpg"></a>
            <a href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf"><img src="/static/assets/faq08.jpg"></a>
            <a @click="qqy"><img src="/static/assets/faq09.jpg"></a>
            <a @click="tsy"><img src="/static/assets/faq10.jpg"></a>
            <!-- <a @click="tv"><img src="/static/assets/faq11.jpg"></a>
            <a @click="safe"><img src="/static/assets/faq12.jpg"></a>
            <a @click="safe"><img src="/static/assets/faq13.jpg"></a>
            <a @click="safe"><img src="/static/assets/faq14.jpg"></a> -->
            <a @click="comm"><img src="/static/assets/faq15.jpg"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Top from '@/components/top.vue'
  export default {
    name: "serve",
    components: {
      Top
    },
    data () {
      return {
        wtlist:[],
        faqData:[],
        id:this.$route.query.id,
        game:this.$route.query.name,
        bgId:'',
        show0:"false",
        show1:"false",
        show2:"false",
        show3:"false",
        qq:false,
        ts:false,
		com:false,
		qqh:'',
		vip:'',
		qqt:'输入QQ号码，点击“验证”，即可进行检验。'
      }
    },
    created() {
      this.bgId='ro'
      this.gameWt()
      //this.getfaq()
    },
    methods:{
      wtBg(name){
        if(name=="账号问题"){
          return ("/static/assets/faq01.jpg");
        }else if(name=="支付问题"){
          return ("/static/assets/faq02.jpg");
        }else if(name=="被盗问题"){
          return ("/static/assets/faq03.jpg");
        }else if(name=="游戏问题"){
          return ("/static/assets/faq04.jpg");
        }else if(name=="其他问题"){
          return ("/static/assets/faq05.jpg");
        }else if(name=="问题反馈"){
          return ("/static/assets/faq16.jpg");
        }else if(name=="攻略提交"){
          return ("/static/assets/faq17.jpg");
        }else if(name=="增值服务"){
          return ("/static/assets/faq18.jpg");
        }
      },
	 //  getfaq(){
		// this.$axios({
		//   method: 'get',
		//   url: '/index.php/user/User/top',
		//   params: {
		//     game_id:this.id
		//   }
		// }).then(res => {
		//   if(res.data.status==200){
		//     this.faqData=res.data.data.slice(0,4);
		// 	this.faqData.forEach((item  )=>{
		// 		item.show=false;
		// 	})
		//   }else{
		//     this.faqData=[]
		//   }
		// })
	 //  },
	 //  an(index){
		// this.faqData[index].show=!this.faqData[index].show
		// this.$forceUpdate();
	 //  },
      gameWt(){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/sort',
          params: {
            gameid:this.id,
          }
        }).then(res => {
          if(res.data.status==200){
            this.wtlist=res.data.data
            this.vip=res.data.vip
          }else if(res.data.status==500){
            //document.cookie=''
			//window.open('https://oauth.tarenwang.net/api/oauth2/authorize?response_type=code&client_id=100300&redirect_uri=https://rokf.zhaouc.com/&scope=MY_PROFILE,MY_REALNAME,MY_GAMES,MY_GAME_USERS,USDK_RO1_USERINFO,USDK_RO1_SERVERS,USDK_RO1_ROLES');
            //this.$router.push({path:"/rologin"})
          }else{
            this.wtlist=[]
          }
        })
      },
	  safe(){
		this.$router.push({path:"/common",query:{id:this.id,name:this.game}})
	  },
	  qqy(){
		  this.qq=!this.qq
		  this.qqt='输入QQ号码，点击“验证”，即可进行检验。'
	  },
	  tsy(){
		  this.ts=!this.ts
	  },
	  // tv(){
		 //  this.tvideo=!this.tvideo
	  // },
	  comm(){
		  this.com=!this.com
	  },
	  tovip(){
			this.$router.push({path:"/common",query:{id:this.id,name:this.game}})
	  },
	  findqq(){
		if(this.qqh.length==0){
			this.qqt='请输入QQ号！'
		}else{
			this.$axios({
			  method: 'get',
			  url: 'http://kf.zhaouc.com/index.php/index/index/findqq',
			  params: {
			    qq:this.qqh,
			  }
			}).then(res => {
				if(res.data.status==200){
					this.qqt='验证结果：这是官方QQ，请放心进行相关操作。'
				}else{
					this.qqt='验证结果：这不是官方QQ，谨防上当!'
				}
			})
		}
	  }
    }
  }
</script>

<style scoped>
	.red {
        background:url(/static/assets/jian.jpg) 0 0 no-repeat;
    }
    .blue {
        background:url(/static/assets/jia.jpg) 0 0 no-repeat;
	}

</style>



// WEBPACK FOOTER //
// src/views/serve.vue